import React, { useEffect, useState } from "react";
import { Alert, Badge, Button, Spinner, Table } from "react-bootstrap";

const formatDate = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleString();
};

const Leads = () => {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [refresh, setRefresh] = useState(0);

  useEffect(() => {
    const controller = new AbortController();

    const fetchLeads = async () => {
      setLoading(true);
      setError("");
      try {
        const response = await fetch(
          "https://api.enrrol.com/api/Seller/getPaymentPolicy",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({}),
            signal: controller.signal,
          }
        );
        if (!response.ok) {
          throw new Error(`Unable to load leads (${response.status}).`);
        }
        const result = await response.json();
        if (String(result.status) !== "0") {
          throw new Error(result.msg || "Unable to load leads.");
        }
        if (!Array.isArray(result.data)) {
          throw new Error("The server returned an unexpected response.");
        }
        if (!controller.signal.aborted) setLeads(result.data);
      } catch (err) {
        if (!controller.signal.aborted) {
          setError(err.message || "Unable to load leads. Please try again.");
        }
      } finally {
        if (!controller.signal.aborted) setLoading(false);
      }
    };

    fetchLeads();
    return () => controller.abort();
  }, [refresh]);

  return (
    <section>
      <div className="d-flex justify-content-between align-items-center mb-4 gap-3">
        <div>
          <h3>Leads</h3>
          <p className="text-muted mb-0">View leads and their payment details.</p>
        </div>
        <Button onClick={() => setRefresh((value) => value + 1)} disabled={loading}>
          {error ? "Retry" : "Refresh"}
        </Button>
      </div>

      {error && <Alert variant="danger">{error}</Alert>}
      {loading ? (
        <div className="text-center py-5" role="status">
          <Spinner animation="border" size="sm" className="me-2" />
          Loading leads…
        </div>
      ) : !error && (
        <div className="card shadow-sm">
          <div className="card-header bg-white fw-semibold">
            All Leads <Badge bg="secondary">{leads.length}</Badge>
          </div>
          {leads.length === 0 ? (
            <p className="text-center text-muted p-5 mb-0">No leads found.</p>
          ) : (
            <Table responsive hover className="mb-0 align-middle">
              <thead className="table-light">
                <tr>
                  {["ID", "Name", "Mobile", "Policy", "Payment Reference", "Payment Status", "Created At", "Updated At"].map((label) => (
                    <th key={label} scope="col" className="text-nowrap">{label}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {leads.map((lead) => (
                  <tr key={lead.id}>
                    <td>{lead.id}</td>
                    <td>{lead.name || "—"}</td>
                    <td>{lead.mobile || "—"}</td>
                    <td>{lead.policy === "Y" ? "Yes" : lead.policy === "N" ? "No" : lead.policy || "—"}</td>
                    <td>{lead.payment_refid || "—"}</td>
                    <td>{lead.payment_status || "—"}</td>
                    <td className="text-nowrap">{formatDate(lead.created_at)}</td>
                    <td className="text-nowrap">{formatDate(lead.updated_at)}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </div>
      )}
    </section>
  );
};

export default Leads;
